module.exports = __webpack_public_path__ + "static/media/chat-square-dots.c018cc3d.svg";